








import { defineComponent } from '@vue/composition-api';
import { useAdCampaignItem } from '@/bundles/Ad/composables/useAdCampaignItem';
import AdCampaignItem from '@/bundles/Ad/models/AdCampaignItem';
import { IUpdateAdItemInfoDto } from '@/bundles/Ad/dto';
import { AdCampaignItemMediaType } from '@/bundles/Ad/types';

import AdItemFormBase from '@/bundles/Ad/components/AdItemFormBase.vue';

export default defineComponent({
  name: 'AdItemEditForm',

  emits: ['ad-item:refresh', 'edit-form:close'],

  components: {
    AdItemFormBase,
  },

  props: {
    adItemEntry: {
      type: AdCampaignItem,
      required: true,
    },
  },

  setup: function (props, { emit }) {
    const { editLoading, update } = useAdCampaignItem();

    async function updateEventHandler ({  url, files, media_type }: { url: string; files: File[]; media_type?: AdCampaignItemMediaType }) {
      try {
        const payload: IUpdateAdItemInfoDto = { url };
        if (files.length) {
          payload.media = files;
        }
        if (media_type) {
          payload.media_type = media_type;
        }
        await update(props.adItemEntry.id, payload);
        emit('edit-form:close');
        emit('ad-item:refresh');
      } catch (error) {
        console.error(error);
      }
    }

    return {
      editLoading,
      updateEventHandler,
    };
  },
});
